export default {
  title_developers: 'Alle Bauträger',
  breadcrumbs: {
    home: 'Startseite',
    developers: 'Bauträger'
  },
  logo_alt: 'Logo des Bauträgers',
  banner_alt: 'Banner des Bauträgers',
  gallery_image_alt: 'Galeriebild',
  founded: 'Gegründet',
  residential_complexes: 'Wohnanlagen',
  buildings: 'Gebäude',
  properties: 'Immobilien',
  no_available: 'Keine verfügbaren Bauträger',
  gallery: 'Fotogalerie',
  video: 'Video',
  contacts: 'Kontakte',
  residential_complexes_from: 'Wohnanlagen von {name}',
  properties_from: 'Immobilien von {name}',
  tabs: {
    base: 'Allgemein',
    media: 'Medien'
  },
  fields: {
    name: 'Name',
    founded_year: 'Gründungsjahr',
    website: 'Webseite',
    email: 'E-Mail',
    phone: 'Telefon',
    country: 'Land',
    description_html: 'Beschreibung (HTML)',
    project_types: 'Projekttypen',
    locations: 'Standorte'
  },
  buttons: {
    more: 'Mehr Details',
    pagination: {
      prev: 'Zurück',
      next: 'Weiter'
    }
  }
}
